module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n/**\n * This block destructures the local variables for use within this ejs template.\n */\nvar instanceID = locals.instanceID;\nvar className = locals.className;\nvar panelTitle = locals.panelTitle;\nvar userToggleable = locals.userToggleable;\n%>\n<div id="netsim-panel-<%= instanceID %>"\n     class="netsim-panel <%= className %>">\n  <h1>\n    <div class="panel-controls"></div>\n    <div class="single-line-with-ellipsis pad-left<% if (userToggleable) { %> minimizer<% } %>">\n      <% if (userToggleable) { %>\n        <i class="fa fa-minus-square"></i>\n      <% } %>\n      <span class="title-text"><%= panelTitle %></span>\n    </div>\n  </h1>\n  <div class="panel-body">\n  </div>\n</div>\n', __filename = "src/netsim/NetSimPanel.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var instanceID = locals.instanceID;
        var className = locals.className;
        var panelTitle = locals.panelTitle;
        var userToggleable = locals.userToggleable;
        __line = 9;
        __append('\n<div id="netsim-panel-');
        __line = 10;
        __append(escapeFn(instanceID));
        __append('"\n     class="netsim-panel ');
        __line = 11;
        __append(escapeFn(className));
        __append('">\n  <h1>\n    <div class="panel-controls"></div>\n    <div class="single-line-with-ellipsis pad-left');
        __line = 14;
        if (userToggleable) {
            __append(" minimizer");
        }
        __append('">\n      ');
        __line = 15;
        if (userToggleable) {
            __append('\n        <i class="fa fa-minus-square"></i>\n      ');
            __line = 17;
        }
        __append('\n      <span class="title-text">');
        __line = 18;
        __append(escapeFn(panelTitle));
        __append('</span>\n    </div>\n  </h1>\n  <div class="panel-body">\n  </div>\n</div>\n');
        __line = 24;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}